// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"960":"9a47fd46","3045":"9a47fd46","4457":"9a47fd46","5016":"9a47fd46","6584":"9a47fd46","8316":"9a47fd46","9048":"9a47fd46"}[chunkId] + ".chunk.css";
};